'use client'

import { useTranslations } from 'next-intl'
import { memo, useMemo } from 'react'
import { useGetCitiesQuery } from '@/api/cities/get-cities-query'
import { ICountry } from '@/api/cities/types/cities-types'
import { CitiesDirectory } from '@/features/cities/cities-directory'
import { InteractiveCitiesSearchListContainer } from '@/features/cities/cities-finder/interactive-cities-search-list-container'

interface IClientInteractiveCitiesSearchListProps {
    className?: string
}

export const ClientInteractiveCitiesSearchList = memo<IClientInteractiveCitiesSearchListProps>(
    ({ className }) => {
        const t = useTranslations()

        const { data } = useGetCitiesQuery({})

        const allCities = data?.data

        const countryCount = useMemo(() => {
            const allCountries = allCities?.reduce<ICountry[]>((acc, city) => {
                if (!city.country) return acc
                const isIncluded = acc.find((country) => country.slug === city.country?.slug)
                return isIncluded ? acc : [...acc, city.country]
            }, [])

            return allCountries?.length
        }, [allCities])

        return (
            <InteractiveCitiesSearchListContainer className={className}>
                <h2 className="text-h3 md:text-h2 mb-2">{t('citySearch.title')}</h2>

                <p className="text-p-sm md:text-p-md text-fg-secondary max-w-[500px] mb-6">
                    {t('citySearch.description', {
                        cityCount: allCities?.length ?? 'x',
                        countryCount: countryCount ?? 'x',
                    })}
                </p>

                <CitiesDirectory variant="page" />
            </InteractiveCitiesSearchListContainer>
        )
    }
)

ClientInteractiveCitiesSearchList.displayName = 'ClientInteractiveCitiesSearchList'
